import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TooltipRoot"], _mergeProps({ "data-slot": "tooltip" }, $setup.forwarded), {
        default: _withCtx((slotProps) => [
            _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(slotProps)))
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */));
}
